import React, { useEffect, useState } from 'react'
import { enums } from '../../../constants'
import utils, { getMessage } from '../../../utils'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import storage from '../../../services/stoage.service'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsInputNumber from '../../../components/lottus/lts-input-number'

export default function ConfigDescontoBB(props) {
  const messages = storage.getAppLabels('configuracaoboleto')

  const parseValue = (value) => {
    if (!value) return {}
    if (typeof value === 'object') return value
    if (typeof value !== 'string') return {}
    try {
      return JSON.parse(value) || {}
    } catch (e) {
      return {}
    }
  }

  const data = parseValue(props.value)
  const tipoDescontoId = data?.tipoDesconto

  const [tipoDesconto, setTipoDesconto] = useState(null)

  useEffect(() => {
    setTipoDesconto(enums.TipoDescontoBB.find((opt) => opt.id === tipoDescontoId) || null)
  }, [tipoDescontoId])

  const emitChange = (next) => {
    if (!props.onChange) return
    props.onChange(JSON.stringify(next))
  }

  const resolvedTipoDesconto = tipoDesconto || enums.TipoDescontoBB.find((opt) => opt.id === data?.tipoDesconto) || null
  const resolvedTipoDescontoId = resolvedTipoDesconto?.id ?? data?.tipoDesconto ?? null

  const showCampos = resolvedTipoDescontoId &&resolvedTipoDescontoId !== 'SEM_DESCONTO'

  const onChangeTipoDesconto = (opt) => {
    const nextTipo = opt || null
    const nextTipoId = nextTipo?.id ?? null

    if (nextTipoId === 'SEM_DESCONTO') {
      setTipoDesconto(nextTipo)

      emitChange({
        tipoDesconto: nextTipoId,
        diasPrimeiroDesconto: null,
        valorPrimeiroDesconto: null,
        diasSegundoDesconto: null,
        valorSegundoDesconto: null,
        diasTerceiroDesconto: null,
        valorTerceiroDesconto: null,
      })
      return
    }

    setTipoDesconto(nextTipo)
    emitChange({ ...data, tipoDesconto: nextTipoId })
  }

  const update = (field, value) => {
    emitChange({
      ...data,
      tipoDesconto: resolvedTipoDescontoId,
      [field]: value ?? null,
    })
  }

  return (
    <>
      <div className="p-col-12">
        <LtsDropdownIdValue
          value={resolvedTipoDesconto}
          options={enums.TipoDescontoBB}
          onChange={onChangeTipoDesconto}
          optionLabel="value"
          optionValue={(v) => v}
          dataKey="id"
          name="TipoDescontoBB"
          label={utils.getMessage(messages, 'configuracaoboleto.label.tipodesconto')}
        />
      </div>

      {showCampos && (
        <>
          <div className="p-col-12 p-md-6">
            <LtsCurrency
              value={data.valorPrimeiroDesconto ?? null}
              onChange={(e) => update('valorPrimeiroDesconto', e)}
              name="valorPrimeiroDesconto"
              label={getMessage(messages, 'configuracaoboleto.label.valorprimeirodesconto')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <LtsInputNumber
              name="diasPrimeiroDesconto"
              value={data.diasPrimeiroDesconto ?? null}
              onChange={(e) => update('diasPrimeiroDesconto', e)}
              label={getMessage(messages, 'configuracaoboleto.label.diasprimeirodesconto')}
              format={false}
            />
          </div>

          <div className="p-col-12 p-md-6">
            <LtsCurrency
              value={data.valorSegundoDesconto ?? null}
              onChange={(e) => update('valorSegundoDesconto', e)}
              name="valorSegundoDesconto"
              label={getMessage(messages, 'configuracaoboleto.label.valorsegundodesconto')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <LtsInputNumber
              name="diasSegundoDesconto"
              value={data.diasSegundoDesconto ?? null}
              onChange={(e) => update('diasSegundoDesconto', e)}
              label={getMessage(messages, 'configuracaoboleto.label.diassegundodesconto')}
              format={false}
            />
          </div>

          <div className="p-col-12 p-md-6">
            <LtsCurrency
              value={data.valorTerceiroDesconto ?? null}
              onChange={(e) => update('valorTerceiroDesconto', e)}
              name="valorTerceiroDesconto"
              label={getMessage(messages, 'configuracaoboleto.label.valorterceirodesconto')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <LtsInputNumber
              name="diasTerceiroDesconto"
              value={data.diasTerceiroDesconto ?? null}
              onChange={(e) => update('diasTerceiroDesconto', e)}
              label={getMessage(messages, 'configuracaoboleto.label.diasterceirodesconto')}
              format={false}
            />
          </div>
        </>
      )}
    </>
  )
}
